import { cn } from '@/lib/utils';

export function SlugChip({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'rounded-sm bg-secondary px-1.5 py-0.5 font-mono text-xs text-foreground-subtle',
        className
      )}
    >
      {children}
    </span>
  );
}
